
import $ from 'jquery';

// Set cookie function
function setCookie (cname, cvalue, exdays) {
  const d = new Date();

  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);

  const expires = `expires='${d.toUTCString()}`;

  document.cookie = `${cname}=${cvalue}; ${expires};path=/`;
}

// Get cookie function
function getCookie (cname) {
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i += 1) {
    const c = ca[i];

    if (c.trim() === `${cname}=true`) {
      return true;
    }
  }

  return false;
}

export default class Cookiebar {
  init () {
    // console.log('Cookiebar init');
    let cookieName = 'persiennkompaniet-se-cookie';

    if (getCookie(cookieName) !== true) {
      $('.js-cookiebar').delay(300).fadeIn();
    }

    // Bind cookiebar button
    $('.js-cookiebar-button').on('click', function (event) {
      event.preventDefault();
      setCookie(cookieName, true, 365);
      $('.js-cookiebar').fadeOut();
    });
  }
}
